module.exports = __webpack_public_path__ + "img/user.719bff6a.png";